





















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { PiningPartsHelper } from '../../NewMultiMessageEditorWithMedia/types'
import { MessageEditorComponentSettings } from "../../types";
import { BaseButton } from './Buttons/types'
import KeyboardSettings from './KeyboardSettings/KeyboardSettings.vue'
import PinButtonsActions from './PinButtonsActions.vue'
import ButtonsManager from './logic/ButtonsManager'

@Component({
  components: {
    KeyboardSettings,
    PinButtonsActions,
  }
})
export default class ButtonsConstructor extends Vue {
  @Prop() buttonsManager!: ButtonsManager

  @Prop() buttons!: Array<Array<BaseButton>>

  @Prop() buttonsHelpView!: MessageEditorComponentSettings['buttonsHelpView']

  @Prop() emptyKeyboardInfo!: MessageEditorComponentSettings['emptyKeyboardInfo']

  @Prop() buttonsRowsMax!: MessageEditorComponentSettings['buttonsInRowMax']

  @Prop() disabled!: MessageEditorComponentSettings['disabled']

  /** Только для MultiMessageEditor */
  @Prop() pinButtonsHelper?: PiningPartsHelper
}
